var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormInput',{staticClass:"control-input",attrs:{"value":_vm._f("keyCodesMap")(_vm.value)},on:{"keydown":_vm.onKeyDown,"keyup":_vm.onKeyUp}})}
var staticRenderFns = []

export { render, staticRenderFns }